export const PHONE_DISPLAY = "+65 8490 0316";
export const PHONE_TEL = "+6584900316";
export const WA_NUMBER = "6584900316";

export const waLink = (
  message = "Hi Lobang Home Inspection! I'd like to book a defect inspection for my new home.",
) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
  general: "Hi Lobang Home Inspection! I'd like to book a defect inspection for my new home.",
  bto: "Hi Lobang! I just collected keys to my BTO flat and would like a defect inspection quote.",
  condo: "Hi Lobang! I'd like a defect inspection quote for my new condominium unit.",
  landed: "Hi Lobang! I'd like to enquire about a defect inspection for my landed property.",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/process", label: "Process" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export const TELEGRAM_URL = "https://t.me/lobanghomeinspection";
// Preserves the hours supplied by the owner; confirm the opening AM/PM before publishing.
export const BUSINESS_HOURS = "Mon – Sat, 8:30 – 6am";
